import React from 'react'
import styles from './Footer.module.css';

function Footer() {
  return (
    <div className={styles.footerContainer}>

    </div>
  )
}

export default Footer